import { Room } from "@domain";
import { SyncInteractor } from "@kernel/frontend-react-app";

export interface EnableRemoteTransceiverInteractorProps {
  room: Room;
  type: "audio" | "video";
}

export class EnableRemoteTransceiverInteractor extends SyncInteractor<
  EnableRemoteTransceiverInteractorProps,
  void
> {
  public execute(props: EnableRemoteTransceiverInteractorProps): void {
    const stream = props.room.localParticipant?.stream || null;
    if (!stream) return;
    const remoteParticipants = props.room.remoteParticipants;
    for (const participant of remoteParticipants.getItems()) {
      participant.enableTransceiver(props.type, stream);
    }
  }

  public static create(): EnableRemoteTransceiverInteractor {
    return new EnableRemoteTransceiverInteractor();
  }
}
